// Shared formatting helpers for GamesNFans article cards (home, category listings).

// Strip HTML tags from titles/excerpts (legacy content was saved as HTML)
export function stripTags(s) {
  if (!s) return '';
  return String(s).replace(/<[^>]+>/g, '').trim();
}

// Local placeholder — displayed when featured_image is missing / 404s.
// Keeps every card at a uniform 16:9 thumbnail ratio even without an image.
export const IMG_PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 225'%3E%3Crect width='400' height='225' fill='%231E293B'/%3E%3Ctext x='50%25' y='50%25' font-family='sans-serif' font-size='16' fill='%23475569' text-anchor='middle' dy='.3em'%3EGamesNFans%3C/text%3E%3C/svg%3E";

// "Just now" / "5m ago" / "3h ago" / "2d ago" then falls back to a short date.
export function formatRelativeTime(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return '';
  const diffSec = Math.floor((Date.now() - date.getTime()) / 1000);
  if (diffSec < 60) return 'Just now';
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = Math.floor(diffHr / 24);
  if (diffDay < 7) return `${diffDay}d ago`;
  return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}
